import {gql} from "@apollo/client";
import useWrappedMutation from "../common/data-fetching/useWrappedMutation";

const QUERY_SCOPE = "employer";
const QUERY_NAME = "employerCreateInternal";

export const QUERY = gql`
    mutation ${QUERY_SCOPE}_${QUERY_NAME} (
       $firstName: String!,
       $lastName: String!,
       $email: String!
       $defaultLanguage: EmployerLanguageEnum
    ) {
      ${QUERY_SCOPE} {
        _id
        ${QUERY_NAME} (
          firstName: $firstName,
          lastName: $lastName,
          email: $email,
          defaultLanguage: $defaultLanguage,
        ) {
          _id
          organization {
            _id
          }   
        }
      }
    }
  `;

export default function useMutationEmployerAdd() {

  return useWrappedMutation(QUERY, QUERY_SCOPE, QUERY_NAME);
}
